var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"m-0 bg-light"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.fileUrl(_vm.product.banner),"alt":_vm.product.name,"itemprop":"image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }